import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';

import MultiselectOption from './MultiselectOption';

class Multiselect extends React.Component {
  handleClickOutside() {
    if (this.props.openedIsOn) {
      this.props.openedToggle();
    }
  }

  render() {
    const dropdownBodyClass = classNames(
      'c-multiselect__dropdown', {
        'is-active': this.props.openedIsOn,
      }
    );

    const dropdownTriggerClass = classNames(
      'c-multiselect__trigger', {
        'is-active': this.props.openedIsOn,
      }
    );

    const canShowSelectAll = this.props.showSelectAll && this.props.options.length > 1;

    return (
      <div className={classNames('c-multiselect', this.props.className)}>
      <span
        className={dropdownTriggerClass}
        onClick={this.props.openedToggle}
      >
        {this.props.title}
      </span>
        <div className={dropdownBodyClass}>
          <div
            display-if={!this.props.options.length}
            className="u-co-gray-3 u-fontsize-extrasmall u-text-center u-p-"
          >
            No options available
          </div>
          <ul className="list-bare" display-if={this.props.options.length}>
            {
              canShowSelectAll && (
                <li>
                  <MultiselectOption
                    onChange={this.props.toggleAll}
                    checked={this.props.areAllSelected}
                    label="Select/Deselect All"
                  />
                </li>
              )
            }
            {
              this.props.options.map((option) => (
                <li key={option.value}>
                  <MultiselectOption
                    label={option.label}
                    onChange={() => this.props.toggleOption(option.value)}
                    checked={this.props.isOptionSelected(option.value)}
                  />
                </li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }
}

Multiselect.defaultProps = {
  showSelectAll: true,
  className: '',
  options: [],
};

Multiselect.propTypes = {
  showSelectAll: PropTypes.bool,
  openedIsOn: PropTypes.bool.isRequired,
  openedToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    label: PropTypes.string,
  })),
  isOptionSelected: PropTypes.func.isRequired,
  toggleAll: PropTypes.func.isRequired,
  toggleOption: PropTypes.func.isRequired,
  areAllSelected: PropTypes.bool.isRequired,
};

export default onClickOutside(Multiselect);
